import { ASSETS_TABLE_STORAGE_KEY } from 'components/DataTable/Views/helpers/tableStorageKeys';
import { getItem, getLocalStorageKeys, removeItems } from 'utils/storage';

export const clearAssetTableColumnPreferences = () => {
  const customerId = getItem('customerId');
  if (!customerId) {
    return;
  }

  const customerSuffix = `:${customerId}`;
  const storageKeyPrefixes = Object.values(ASSETS_TABLE_STORAGE_KEY).map((key) => `${key}:`);
  const customerPreferenceKeys = getLocalStorageKeys().filter(
    (key) =>
      key.endsWith(customerSuffix) &&
      storageKeyPrefixes.some((storageKeyPrefix) => key.startsWith(storageKeyPrefix))
  );

  removeItems(customerPreferenceKeys);
};
